import cx from 'classnames';
import { ClockClear as ClockIcon } from 'education-icons';
import React from 'react';

import { TEXT_MARKUP_TYPE } from '../../constants';
import Text from '../../text/text';

import './lesson-meta__duration.scss';

class Props {
    duration: number | null;
    showIcon: boolean;
    mix?: string;
    shouldShowEmptyDuration?: boolean;
}

export const Duration = ({ duration, mix, showIcon, shouldShowEmptyDuration }: Props) => {
    if (!duration) {
        if (shouldShowEmptyDuration) {
            return (
                <span className={cx('lesson-meta__duration', mix)}>
                    {showIcon && <ClockIcon className="lesson-meta__duration-icon" />}
                    <Text id="lesson-meta.duration.empty" type={TEXT_MARKUP_TYPE.MARKDOWN} />
                </span>
            );
        }

        return null;
    }

    return (
        <span className={cx('lesson-meta__duration', mix)}>
            {showIcon && <ClockIcon className="lesson-meta__duration-icon" />}
            <Text
                id={'lesson-meta.duration'}
                type={TEXT_MARKUP_TYPE.MARKDOWN}
                values={{
                    duration,
                }}
            />
        </span>
    );
};

Duration.defaultProps = {
    showIcon: false,
};

export default Duration;
